/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  LoginMutationRequest,
  LoginMutationResponse,
  Login401,
  Login403,
} from '../types/Login'

function getLoginUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/login/` as const }
  return res
}

/**
 * @description Check the credentials and return the REST Token
 * if the credentials are valid and authenticated.
 * Calls Django Auth login method to register User ID
 * in Django session framework
 * Accept the following POST parameters: username, password
 * Return the REST Framework Token Object's key.
 * @summary Authenticate with email + password
 * {@link /api/v1/auth/login/}
 */
export async function login(
  data: LoginMutationRequest,
  config: Partial<RequestConfig<LoginMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    LoginMutationResponse,
    ResponseErrorConfig<Login401 | Login403>,
    LoginMutationRequest
  >({
    method: 'POST',
    url: getLoginUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
